import useAuthContext from './useAuthContext'

const useJWTToken = () => {
    const {
        token,
    } = useAuthContext()

    return token
}

export default useJWTToken
